<template>
    <div class="room" :style="'font-family:' + fontFamily">
        <v-text-field
                v-model="room.name"
                v-if="hasField('NAME')"
                :label="getField('NAME').name"
                hide-details
                outlined>
        </v-text-field>

        <v-textarea
                class="textarea mt-5"
                v-if="hasField('ROOM_DESCRIPTION')"
                :label="getField('ROOM_DESCRIPTION').name"
                v-model="room.description"
                outlined>
        </v-textarea>

        <div class="d-flex justify-content-between flex-wrap">
            <v-text-field
                    :label="getField('MAX_CAPACITY_PERS').name"
                    v-if="hasField('MAX_CAPACITY_PERS')"
                    class="mr-sm-4"
                    type="number"
                    @keydown="filterInput"
                    min="0"
                    v-model="room.max_capacity"
                    outlined>
            </v-text-field>

            <v-text-field
                    :label="getField('AREA').name"
                    v-if="hasField('AREA')"
                    v-model="room.area"
                    :class="{'input-error': !isValidArea}"
                    type="number"
                    @keydown="filterInput"
                    min="0"
                    outlined>
            </v-text-field>

            <v-text-field
                    :label="getField('ROOM_HEIGHT').name"
                    v-if="hasField('ROOM_HEIGHT')"
                    class="ml-md-4 ml-sm-0"
                    v-model="room.height"
                    type="number"
                    @keydown="filterInput"
                    min="0"
                    step="0.1"
                    outlined>
            </v-text-field>
        </div>

        <v-checkbox v-model="room.natural_light"
                    v-if="hasField('NATURAL_LIGHT')"
                    :label="getField('NATURAL_LIGHT').name"
                    class="mt-0"
                    hide-details>
        </v-checkbox>

        <h5 style="font-size: 19px" class="mt-4 mb-5" v-if="hasRoomCapacitiesToDisplay()">
            Capacités par disposition
        </h5>

        <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex">
                <v-img height="40px" width="40px" src="/images/rooms/U.png" class="mr-2"></v-img>

                <v-text-field
                    :label="getField('ROOM_U').name"
                    style="padding-top: 0 !important;"
                    v-if="hasField('ROOM_U')"
                    type="number"
                    @keydown="filterInput"
                    min="0"
                    v-model="room.u_shape_capacity"
                    outlined>
                </v-text-field>
            </div>

            <div class="d-flex">
                <v-img height="40px" width="40px" src="/images/rooms/banquet.png" class="mr-2"></v-img>

                <v-text-field
                    :label="getField('ROOM_BANQUET').name"
                    style="padding-top: 0 !important;"
                    v-if="hasField('ROOM_BANQUET')"
                    type="number"
                    @keydown="filterInput"
                    min="0"
                    v-model="room.banquet_capacity"
                    outlined>
                </v-text-field>
            </div>

            <div class="d-flex">
                <v-img height="40px" width="40px" src="/images/rooms/carre.png" class="mr-2"></v-img>

                <v-text-field
                    :label="getField('ROOM_SQUARE').name"
                    style="padding-top: 0 !important;"
                    v-if="hasField('ROOM_SQUARE')"
                    type="number"
                    @keydown="filterInput"
                    min="0"
                    v-model="room.square_capacity"
                    outlined>
                </v-text-field>
            </div>
        </div>

        <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex">
                <v-img height="40px" width="40px" src="/images/rooms/classe.png" class="mr-2"></v-img>

                <v-text-field
                    :label="getField('ROOM_CLASS').name"
                    style="padding-top: 0 !important;"
                    v-if="hasField('ROOM_CLASS')"
                    type="number"
                    @keydown="filterInput"
                    min="0"
                    v-model="room.classroom_capacity"
                    outlined>
                </v-text-field>
            </div>

            <div class="d-flex">
                <v-img height="40px" width="40px" src="/images/rooms/cocktail.png" class="mr-2"></v-img>

                <v-text-field
                    :label="getField('ROOM_COCKTAIL').name"
                    style="padding-top: 0 !important;"
                    v-if="hasField('ROOM_COCKTAIL')"
                    type="number"
                    @keydown="filterInput"
                    min="0"
                    v-model="room.cocktail_capacity"
                    outlined>
                </v-text-field>
            </div>

            <div class="d-flex">
                <v-img height="40px" width="40px" src="/images/rooms/theatre.png" class="mr-2"></v-img>

                <v-text-field
                    :label="getField('ROOM_THEATRE').name"
                    style="padding-top: 0 !important;"
                    v-if="hasField('ROOM_THEATRE')"
                    type="number"
                    @keydown="filterInput"
                    min="0"
                    v-model="room.theatre_style_capacity"
                    outlined>
                </v-text-field>
            </div>
        </div>

        <v-alert v-if="requiredName" type="error" class="mt-5 text-left">Le nom de la salle est requis.</v-alert>
        <v-alert v-if="!isValidArea" type="error" class="mt-5 text-left">La superficie doit être un nombre entier.</v-alert>

        <div class="text-center w-100">
            <v-btn class="text-none"
                   @click="prepareAddRoom"
                   v-if="!edit"
                   :color="primaryColor"
                   style="border-radius: 20px; color: white">
                Ajouter
            </v-btn>

            <v-btn class="text-none"
                   v-else
                   @click="saveRoom"
                   :color="primaryColor"
                   style="border-radius: 20px; color: white">
                Enregistrer
            </v-btn>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapMutations, mapState} from "vuex"

    export default {
        name: "Room",
        props: ['room', 'requiredField', 'edit'],
        data() {
            return {
                requiredName: this.requiredField
            }
        },
        methods: {
            ...mapMutations('web_form', ['deleteRoom', 'addRoom']),
            hasRoomCapacitiesToDisplay() {
                return this.hasField('ROOM_U') ||
                    this.hasField('ROOM_BANQUET') ||
                    this.hasField('ROOM_SQUARE') ||
                    this.hasField('ROOM_CLASS') ||
                    this.hasField('ROOM_COCKTAIL') ||
                    this.hasField('ROOM_THEATRE')
            },
            prepareAddRoom() {
                if(this.room.name !== null && this.room.name !== '') {
                    this.addRoom(this.room)

                    this.requiredName = false

                    this.$global.$emit('close-dialog')
                } else {
                    this.requiredName = true
                }
            },
            saveRoom() {
                if(this.room.name !== null && this.room.name !== '' && this.isValidArea) {
                    this.requiredName = false

                    this.$global.$emit('close-dialog', this.room)
                } else if(this.room.name === null || this.room.name === '') {
                    this.requiredName = true
                }
            },
            filterInput(event) {
                const invalidChars = ['e', 'E', '+', '-']

                if (invalidChars.includes(event.key)) {
                    event.preventDefault()
                }
            }
        },
        computed: {
            ...mapState('web_form', ['disabled', 'provider']),
            ...mapState('webFormStyle', ['fontFamily', 'primaryColor', 'titlesColor', 'fieldsColor', 'backGroundColor']),
            ...mapGetters('web_form', ['hasField', 'hasFamilyElement', 'getFamilyByCode', 'getElementsByFamilyCode', 'getField']),
            isValidArea() {
                return this.room.area === null || this.room.area.toString().indexOf(".") === -1
            }
        },
        created() {
            this.$global.$on('init-required-fields', () => {
                this.requiredName = false
            })
        },
        beforeDestroy() {
            this.$global.$off('init-required-fields')
        }
    }
</script>